import { motion } from "framer-motion";

export const Container = ({ className = "", children }) => (
    <div className={`mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`}>
        {children}
    </div>
);

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children }) => (
    <span className="inline-flex items-center gap-2 rounded-full border border-[#16A34A]/20 bg-[#F0FDF4] px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#15803D]">
        <span className="h-1.5 w-1.5 rounded-full bg-[#16A34A]" />
        {children}
    </span>
);

export const SectionHeader = ({ eyebrow, title, sub, align = "center" }) => (
    <div
        className={`max-w-3xl ${
            align === "center" ? "mx-auto text-center" : "text-left"
        }`}
    >
        {eyebrow && (
            <Reveal>
                <Eyebrow>{eyebrow}</Eyebrow>
            </Reveal>
        )}
        <Reveal delay={0.08}>
            <h2 className="mt-5 text-balance text-3xl font-bold leading-[1.15] tracking-tight text-[#111827] sm:text-4xl lg:text-[44px]">
                {title}
            </h2>
        </Reveal>
        {sub && (
            <Reveal delay={0.16}>
                <p className="mt-4 text-base leading-relaxed text-[#64748B] sm:text-lg">
                    {sub}
                </p>
            </Reveal>
        )}
    </div>
);

export const GreenWord = ({ children }) => (
    <span className="relative inline-block text-[#16A34A]">
        {children}
        <svg
            className="absolute -bottom-1.5 left-0 w-full"
            viewBox="0 0 220 12"
            fill="none"
            preserveAspectRatio="none"
            aria-hidden="true"
        >
            <path
                d="M2 9C60 3 160 3 218 8"
                stroke="#16A34A"
                strokeOpacity="0.35"
                strokeWidth="5"
                strokeLinecap="round"
            />
        </svg>
    </span>
);
